export default "__VITE_ASSET__B1N6zxBL__"